import { render, staticRenderFns } from "./activity_secondkill_edit.vue?vue&type=template&id=18cf54bc&scoped=true"
import script from "./activity_secondkill_edit.vue?vue&type=script&lang=js"
export * from "./activity_secondkill_edit.vue?vue&type=script&lang=js"
import style0 from "./activity_secondkill_edit.vue?vue&type=style&index=0&id=18cf54bc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cf54bc",
  null
  
)

export default component.exports